import React, { useEffect, useState, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Notification from "../../components/Notification";
import { API_URL } from "../../config";

const ProductForm = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [product, setProduct] = useState({
        name: "",
        description: "",
        price: ""
    });
    const [notification, setNotification] = useState(null);
    const token = localStorage.getItem("access_token");
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);

    const loadProduct = useCallback(async () => {
        if (!id) return;

        const response = await fetch(`${API_URL}/products/${id}`, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        if (response.ok) {
            const data = await response.json();
            setProduct(data);
        } else if (response.status === 401) {
            navigate("/logout");
        } else {
            const errorData = await response.json();
            setErrors(errorData || {});
            setNotification({ message: errorData.message || "An error occurred.", type: "danger" });
        }

    }, [id, navigate, token]);

    useEffect(() => {
        loadProduct();
    }, [loadProduct]);

    const handleChange = (e) => {
        setProduct({ ...product, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        try {
            e.preventDefault();
            setErrors({});
            setLoading(true)
            const method =  "POST";
            const url = id ? `${API_URL}/products/${id}` : `${API_URL}/products`;

            const formData = new FormData();

            for (const key in product) {
                if (product[key] === null || product[key] === "") {
                    formData.delete(key);
                } else {
                    formData.append(key, product[key]);
                }
            }

            const response = await fetch(url, {
                method: method,
                headers: {
                    Authorization: `Bearer ${token}`
                },
                body: formData,
            });

            if (response.ok) {
                setNotification({ type: "success", message: id ? "Product updated successfully!" : "Product added successfully!" });
                setTimeout(() => navigate("/dashboard/products"), 2000);
            } else if (response.status === 401) {
                navigate("/logout");
            } else {
                const errorData = await response.json();
                setErrors(errorData || {});
                setNotification({ message: errorData.message || "An error occurred.", type: "danger" });
            }
        } catch (error) {
            setNotification({ message: error.message || "An error occurred.", type: "danger" });
            console.error("Error:", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container">
            <div className="py-4">
                {notification && <Notification type={notification.type} message={notification.message} />}
                <h2 className="title is-4">{id ? "Update Product" : "Add Product"}</h2>
                <form onSubmit={handleSubmit}>
                    <div className="field">
                        <label className="label">Name</label>
                        <div className="control">
                            <input type="text" className={`input ${errors.name ? "is-danger" : ""}`} name="name" value={product.name} onChange={handleChange} placeholder="e.g Bakex Bran 50 KG" required />
                        </div>
                        {errors.name && <p className="help is-danger">{errors.name}</p>}
                    </div>
                    <div className="field">
                        <label className="label">Price</label>
                        <div className="control">
                            <input type="number" className={`input ${errors.price ? "is-danger" : ""}`} name="price" value={product.price} onChange={handleChange} />
                        </div>
                        {errors.price && <p className="help is-danger">{errors.price}</p>}
                    </div>
                    <div className="field">
                        <label className="label">Description</label>
                        <div className="control">
                            <textarea className={`textarea ${errors.description ? "is-danger" : ""}`} name="description" value={product.description} onChange={handleChange}></textarea>
                        </div>
                        {errors.description && <p className="help is-danger">{errors.description}</p>}
                    </div>
                    <div className="level mt-4">
                        <div className="level-left">
                            <button type="submit" className="button primary-bg is-fullwidth" disabled={loading}>
                                {loading ? "Loading..." : id ? "Update Product" : "Add Product"}
                            </button>

                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ProductForm;
